import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getReportData, getReportHeader } from '../../../services'

export const EMPTY_REPORT = {
  resultALL: [],
  pagination: { total: 0, page: 1, limit: 20, pages: 0 },
}

const initialState = {
  headers: [],
  reportData: EMPTY_REPORT,
  statusHeaders: '',
  statusData: '',
  currentDataRequestId: null,
}

export const getReportHeadersThunk = createAsyncThunk('report/headers', async () => {
  return await getReportHeader()
})

export const getReportDataThunk = createAsyncThunk(
  'report/data',
  async ({ tenantId, page, limit, habilitado, especieId, parroquiaId, tipoZonaId, sitioId }, { signal }) => {
    return await getReportData({ tenantId, page, limit, habilitado, especieId, parroquiaId, tipoZonaId, sitioId, signal })
  }
)

export const reportSlice = createSlice({
  name: 'reportSlice',
  initialState,
  reducers: {
    setStatusData: (state, action) => {
      state.statusData = action.payload
    },
    setStatusHeaders: (state, action) => {
      state.statusHeaders = action.payload
    },
    setReportData: (state, action) => {
      state.reportData = action.payload
    },
    setHeaders: (state, action) => {
      state.headers = action.payload
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getReportHeadersThunk.pending, state => {
        state.statusHeaders = 'loading'
      })
      .addCase(getReportHeadersThunk.fulfilled, (state, action) => {
        state.statusHeaders = 'succeeded'
        state.headers = action.payload
      })
      .addCase(getReportHeadersThunk.rejected, state => {
        state.statusHeaders = 'failed'
      })

    builder
      .addCase(getReportDataThunk.pending, (state, action) => {
        state.statusData = 'loading'
        state.currentDataRequestId = action.meta.requestId
      })
      .addCase(getReportDataThunk.fulfilled, (state, action) => {
        if (state.currentDataRequestId !== action.meta.requestId) return
        state.statusData = 'succeeded'
        state.reportData = action.payload
        state.currentDataRequestId = null
      })
      .addCase(getReportDataThunk.rejected, (state, action) => {
        if (action.meta.aborted) {
          state.statusData = ''
          state.currentDataRequestId = null
          return
        }
        if (state.currentDataRequestId !== action.meta.requestId) return
        state.statusData = 'failed'
        state.currentDataRequestId = null
      })
  },
})

export const { setStatusData, setStatusHeaders, setReportData, setHeaders } =
  reportSlice.actions
export default reportSlice.reducer
